var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutBase",
    [
      _c(
        "header",
        { attrs: { id: "content__header" } },
        [
          _vm.resource.avatar
            ? _c("img", {
                staticClass: "avatar",
                attrs: {
                  src: `/images/avatar/${_vm.resource.id}`,
                  alt: `Avatar for ${_vm.resource.name}`,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "user-name" }, [
            _c("h1", [_vm._v(_vm._s(_vm.resource.name))]),
            _vm._v(" "),
            _c("h3", [_vm._v(_vm._s(_vm.resource.member.name))]),
          ]),
          _vm._v(" "),
          _vm.resource.can.edit
            ? _c(
                "router-link",
                {
                  staticClass: "btn btn--primary",
                  attrs: {
                    to: {
                      name: "edit-user",
                      params: { user_id: _vm.resource.id },
                    },
                  },
                },
                [_vm._v("\n\t\t\t\tEdit\n\t\t\t")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("ul", { staticClass: "grid post-details" }, [
            _vm.resource.phone
              ? _c(
                  "li",
                  {
                    staticClass:
                      "col-12 col-md-4 col-xlg-3 col-md-bleed-y detail",
                  },
                  [
                    _c("span", { staticClass: "label" }, [_vm._v("Telephone")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      { attrs: { href: "tel:" + _vm.resource.phone } },
                      [
                        _c("SvgIcon", { attrs: { icon: "phone" } }),
                        _vm._v(_vm._s(_vm.resource.phone)),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resource.email
              ? _c(
                  "li",
                  {
                    staticClass:
                      "col-12 col-md-4 col-xlg-3 col-md-bleed-y detail",
                  },
                  [
                    _c("span", { staticClass: "label" }, [_vm._v("Email")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "mailto:" + _vm.resource.email,
                          target: "_blank",
                        },
                      },
                      [
                        _c("SvgIcon", { attrs: { icon: "email" } }),
                        _vm._v(_vm._s(_vm.resource.email)),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resource.languages
              ? _c(
                  "li",
                  {
                    staticClass:
                      "col-12 col-md-4 col-xlg-3 col-md-bleed-y detail",
                  },
                  [
                    _c("span", { staticClass: "label" }, [_vm._v("Languages")]),
                    _vm._v(" "),
                    _c(
                      "h3",
                      [
                        _c("SvgIcon", { attrs: { icon: "language" } }),
                        _vm._v(" " + _vm._s(_vm.resource.languages)),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resource.office && _vm.resource.office.location
              ? _c(
                  "li",
                  {
                    staticClass:
                      "col-12 col-md-4 col-xlg-3 col-md-bleed-y detail",
                  },
                  [
                    _c("span", { staticClass: "label" }, [_vm._v("Location")]),
                    _vm._v(" "),
                    _c(
                      "h3",
                      [
                        _c("SvgIcon", { attrs: { icon: "location" } }),
                        _vm._v(" " + _vm._s(_vm.resource.office.location)),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resource.position
              ? _c(
                  "li",
                  {
                    staticClass:
                      "col-12 col-md-4 col-xlg-3 col-md-bleed-y detail",
                  },
                  [
                    _c("span", { staticClass: "label" }, [_vm._v("Position")]),
                    _vm._v(" "),
                    _c(
                      "h3",
                      [
                        _c("SvgIcon", { attrs: { icon: "position" } }),
                        _vm._v(" " + _vm._s(_vm.resource.position)),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resource.specialisms
              ? _c(
                  "li",
                  { staticClass: "col-12 detail" },
                  [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("Sectors expertise"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.resource.specialisms, function (specialism) {
                      return _c("span", { staticClass: "sector" }, [
                        _vm._v(_vm._s(specialism.name)),
                      ])
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vue-tabs",
        { ref: "tabs", on: { "tab-change": _vm.onTabChange } },
        [
          _c("v-tab", { attrs: { id: "background", title: "Background" } }, [
            _c("div", { staticClass: "grid" }, [
              _c("div", { staticClass: "col-12 col-md-8" }, [
                _vm.resource.background
                  ? _c("div", { staticClass: "card" }, [
                      _c("h4", { staticClass: "header" }, [
                        _vm._v("Background"),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.resource.background) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.resource.expertise
                  ? _c("div", { staticClass: "card" }, [
                      _c("h4", { staticClass: "header" }, [
                        _vm._v("Expertise"),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.resource.expertise) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.resource.career
                  ? _c("div", { staticClass: "card" }, [
                      _c("h4", { staticClass: "header" }, [_vm._v("Career")]),
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.resource.career) +
                          "\n\t\t\t\t\t\t"
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-4" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "card card--image",
                      attrs: {
                        to: {
                          name: "view-member",
                          params: { id: _vm.resource.member.id },
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: `/images/logo/${_vm.resource.member.id}`,
                          alt: `Logo for ${_vm.resource.member.name}`,
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "opportunities", title: "Opportunities" } },
            [
              _c("div", { staticClass: "toolbar" }, [
                _c("fieldset", { staticClass: "toolbar__filters" }, [
                  _c(
                    "div",
                    { staticClass: "flex-fix" },
                    [
                      _c("FormControlSector", {
                        attrs: {
                          name: "sectors",
                          multiple: true,
                          "include-ancestors": false,
                        },
                        model: {
                          value: _vm.oppFilters.sectors,
                          callback: function ($$v) {
                            _vm.$set(_vm.oppFilters, "sectors", $$v)
                          },
                          expression: "oppFilters.sectors",
                        },
                      }),
                      _vm._v(" "),
                      _c("FormControlDealType", {
                        attrs: { name: "dealType" },
                        model: {
                          value: _vm.oppFilters.dealType,
                          callback: function ($$v) {
                            _vm.$set(_vm.oppFilters, "dealType", $$v)
                          },
                          expression: "oppFilters.dealType",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("fieldset", { staticClass: "toolbar__search" }, [
                  _c("div", { staticClass: "flex-fix" }, [
                    _c("div", { staticClass: "form__group search" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form__label",
                          attrs: { for: "opp-search" },
                        },
                        [_vm._v("Search Opportunities")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.oppFilters.query,
                            expression: "oppFilters.query",
                          },
                        ],
                        staticClass: "form__control search",
                        attrs: {
                          id: "opp-search",
                          type: "search",
                          placeholder: "Search Opportunities...",
                        },
                        domProps: { value: _vm.oppFilters.query },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.oppFilters,
                              "query",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("ListOpportunities", {
                ref: "opportunities",
                attrs: { "load-on-start": false, filters: _vm.oppFilters },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "madds", title: "MADDs" } },
            [
              _c("div", { staticClass: "toolbar" }, [
                _c("fieldset", { staticClass: "toolbar__filters" }, [
                  _c(
                    "div",
                    { staticClass: "flex-fix" },
                    [
                      _c("FormControlSector", {
                        attrs: {
                          name: "sectors",
                          multiple: true,
                          "include-ancestors": false,
                        },
                        model: {
                          value: _vm.maddFilters.sectors,
                          callback: function ($$v) {
                            _vm.$set(_vm.maddFilters, "sectors", $$v)
                          },
                          expression: "maddFilters.sectors",
                        },
                      }),
                      _vm._v(" "),
                      _c("FormControlDealType", {
                        attrs: { name: "dealType" },
                        model: {
                          value: _vm.maddFilters.dealType,
                          callback: function ($$v) {
                            _vm.$set(_vm.maddFilters, "dealType", $$v)
                          },
                          expression: "maddFilters.dealType",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("fieldset", { staticClass: "toolbar__search" }, [
                  _c("div", { staticClass: "flex-fix" }, [
                    _c("div", { staticClass: "form__group search" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form__label",
                          attrs: { for: "madd-search" },
                        },
                        [_vm._v("Search MADDs")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.maddFilters.query,
                            expression: "maddFilters.query",
                          },
                        ],
                        staticClass: "form__control search",
                        attrs: {
                          id: "madd-search",
                          type: "search",
                          placeholder: "Search MADDs...",
                        },
                        domProps: { value: _vm.maddFilters.query },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.maddFilters,
                              "query",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("ListMADDs", {
                ref: "madds",
                attrs: { "load-on-start": false, filters: _vm.maddFilters },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "intelligence", title: "Intelligence" } },
            [
              _c("div", { staticClass: "toolbar" }, [
                _c("fieldset", { staticClass: "toolbar__filters" }, [
                  _c(
                    "div",
                    { staticClass: "flex-fix" },
                    [
                      _c("FormControlSector", {
                        attrs: {
                          name: "sectors",
                          multiple: true,
                          "include-ancestors": false,
                        },
                        model: {
                          value: _vm.intFilters.sectors,
                          callback: function ($$v) {
                            _vm.$set(_vm.intFilters, "sectors", $$v)
                          },
                          expression: "intFilters.sectors",
                        },
                      }),
                      _vm._v(" "),
                      _c("FormControlDealType", {
                        attrs: { name: "dealType" },
                        model: {
                          value: _vm.intFilters.dealType,
                          callback: function ($$v) {
                            _vm.$set(_vm.intFilters, "dealType", $$v)
                          },
                          expression: "intFilters.dealType",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("fieldset", { staticClass: "toolbar__search" }, [
                  _c("div", { staticClass: "flex-fix" }, [
                    _c("div", { staticClass: "form__group search" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form__label",
                          attrs: { for: "int-search" },
                        },
                        [_vm._v("Search Intelligence")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.intFilters.query,
                            expression: "intFilters.query",
                          },
                        ],
                        staticClass: "form__control search",
                        attrs: {
                          id: "int-search",
                          type: "search",
                          placeholder: "Search Intelligence...",
                        },
                        domProps: { value: _vm.intFilters.query },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.intFilters,
                              "query",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("ListIntelligence", {
                ref: "intelligence",
                attrs: { "load-on-start": false, filters: _vm.intFilters },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }